import { React, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Edit, Trash2 } from "react-feather";
import { toast } from "react-toastify";
// import { useSelector } from "react-redux";
import Table from "../../core/pagination/datatable";
import SupplierModal from "../../core/modals/peoples/supplierModal";
import TooltipIcons from "../../core/common/tooltip-content/tooltipIcons";
import RefreshIcon from "../../core/common/tooltip-content/refresh";
import CollapesIcon from "../../core/common/tooltip-content/collapes";
import { fetchSuppliers, deleteSupplier } from "../../api/supplier";

const Suppliers = () => {
  // ✅ same helpers as biller.jsx
  const normalizeKey = (s) => {
    if (!s) return "";
    let v = String(s).trim();
    v = v.replace(/^\/+/, "");
    v = v.replace(/^catelog\//i, "catalog/");
    if (!/^catalog\//i.test(v)) v = `catalog/${v.split("/").pop()}`;
    return v;
  };
  const toPublicUrl = (v) => {
    if (!v) return "";
    if (/^https?:\/\//i.test(v)) return v;
    const key = normalizeKey(v);
    const base = (
      process.env.REACT_APP_API_IMAGE_BASE_URL ||
      "https://hamilton-shop-images.s3.ap-south-1.amazonaws.com"
    ).replace(/\/+$/, "");
    return `${base}/${key}`;
  };

  // const data = useSelector((state) => state.rootReducer.supplierdata);
  const [suppliers, setSuppliers] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [deleteSupplierId, setDeleteSupplierId] = useState(null);

  useEffect(() => {
    const getSuppliers = async () => {
      try {
        const data = await fetchSuppliers();
        setSuppliers(data);
      } catch (err) {
        console.error("Error fetching suppliers:", err);
      }
    };

    getSuppliers();
  }, []);

  const handleDeleteSupplier = async () => {
    if (!deleteSupplierId) return;

    try {
      await deleteSupplier(deleteSupplierId);
      // toast.success("✅ Supplier deleted successfully");
      toast.success(` ${window.translate("Supplier deleted successfully")}`);
      // Remove from UI
      setSuppliers((prev) => prev.filter((s) => s.id !== deleteSupplierId));
      setDeleteSupplierId(null);
      document.getElementById("close-add-stock-btn")?.click();
      // Reload after short delay
      setTimeout(() => {
        window.location.reload();
      }, 800);
    } catch (error) {
      // toast.error("❌ Failed to delete supplier");
      toast.error(`❌ ${window.translate("Failed to delete supplier")}`);
    }
  };

  const columns = [
    {
      title: window.translate("Code"),
      dataIndex: "code",
      sorter: (a, b) => a.code.length - b.code.length,
    },
    {
      title: window.translate("Supplier Name"),
      dataIndex: "supplierName",
      render: (text, record) => {
        const imgSrc = toPublicUrl(
          record.image || record.logo || "/assets/img/users/default-avatar.png"
        );
        return (
          <span className="productimgname">
            <Link to="#" className="avatar avatar-md me-2">
              <img
                src={imgSrc}
                alt="supplier"
                className="object-fit-cover h-100 rounded-1"
                style={{ width: 40, height: 40, objectFit: "cover" }}
              />
            </Link>
            <Link to="#">{text}</Link>
          </span>
        );
      },
      sorter: (a, b) =>
        (a.supplierName || "").length - (b.supplierName || "").length,
    },

    {
      title: window.translate("Email"),
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
    },

    {
      title: window.translate("Phone"),
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
    },

    {
      title: window.translate("Country"),
      dataIndex: "country",
      sorter: (a, b) => a.country.length - b.country.length,
    },
    {
      title: window.translate("Status"),
      dataIndex: "status",
      render: (text) => (
        <>
          <span
            className={`badge  d-inline-flex align-items-center badge-xs ${
              text === "Active" ? "badge-success" : "badge-danger"
            }`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </span>
        </>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
    },

    {
      title: "",
      dataIndex: "action",
      render: (
        _,
        record // <-- include both "_" and "record"
      ) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>

            {/* <Link className="me-2 p-2" to="#">
              <Eye className="feather-view" />
            </Link> */}

            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#edit-supplier"
              onClick={() => setSelectedSupplier(record)} // <-- this uses record now
            >
              <Edit className="feather-edit" />
            </Link>

            <Link
              className="confirm-text p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete-modal"
              onClick={() => setDeleteSupplierId(record.id)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{window.translate("Suppliers")}</h4>
                <h6>{window.translate("Manage your suppliers")}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <TooltipIcons />
              <RefreshIcon />
              <CollapesIcon />
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add-supplier"
              >
                <i className="ti ti-circle-plus me-2 ms-2"></i>
                {window.translate("Add Supplier")}
              </Link>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center d-none"
                    data-bs-toggle="dropdown"
                  >
                    {window.translate("status")}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        {window.translate("active")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        In{window.translate("active")}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        New Joiners
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                {suppliers.length > 0 ? (
                  <Table
                    className="table datanew"
                    columns={columns}
                    dataSource={suppliers}
                    rowKey={(record) => record.id}
                  />
                ) : (
                  <p className="text-center mt-3">
                    {window.translate("No supplier data available")}.
                  </p>
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <SupplierModal
        selectedSupplier={selectedSupplier}
        deleteSupplierId={deleteSupplierId}
        onDeleteSupplier={handleDeleteSupplier}
      />
    </>
  );
};

export default Suppliers;
